import {filter} from "lodash/collection";
import {findIndex} from "lodash/array";
import { http } from '../../http';

export default {
    state: {
        sendables: [],
        available_tags: [],
        available_templates: [],
        available_filters: [],
        sendables_loading: false,
        is_tags_loaded : false,
        is_templates_loaded : false,
        is_filters_loaded : false,
        active_resource_type : null,
        sendable : null, //This is the sendable currently being edited in settings
    },

    mutations: {

        setActiveResourceType(state, resource_type) {
            state.active_resource_type = resource_type;
        },

        setSendables(state, data) {
            state.sendables = data;
        },

        setSendable(state, data) {
            state.sendable = data;
        },

        setAvailableTags(state, data) {
            state.available_tags = data;
        },

        setAvailableFilters(state, data) {
            state.available_filters = data;
        },

        setAvailableTemplates(state, data) {
            state.available_templates = data;
        },

        setIsLoading(state, isLoading = true) {
            state.sendables_loading = isLoading;
        },

        deleteSendable(state, id){
            let index = state.sendables.findIndex(sendable => sendable.id == id);
            state.sendables.splice(index, 1);
        }

    },

    getters: {

        getActiveResourceType: (state, getters) => {
            return state.active_resource_type;
        },

        getSendables: (state, getters) => {
            return state.sendables;
        },

        getSendable: (state, getters) => {
            return state.sendable;
        },

        getAvailableTemplates: (state, getters) => {
            return state.available_templates;
        },

        getAvailableTags: (state, getters) => {
            return state.available_tags;
        },

        getAvailableFilters: (state, getters) => {
            return state.available_filters;
        },

        getSendablesSentBefore: (state, getters) => {
            return filter(state.sendables, (sendable) => {
                return sendable.should_be_sent_before_resource;
            });
        },

        getSendablesSentOnCreate: (state, getters) => {
            return filter(state.sendables, (sendable) => {
                return sendable.sending_schedule === 'on_creation';
            });
        },

        getSendablesSentOnUpdate: (state, getters) => {
            return filter(state.sendables, (sendable) => {
                return sendable.sending_schedule === 'on_update';
            });
        },

        getSendablesSentOnDelete: (state, getters) => {
            return filter(state.sendables, (sendable) => {
                return sendable.sending_schedule === 'on_delete';
            });
        },

        getSendablesSentOnStart: (state, getters) => {
            return filter(state.sendables, (sendable) => {
                return sendable.sending_schedule === 'on_start';
            });
        },

        getSendablesSentAfter: (state, getters) => {
            return filter(state.sendables, (sendable) => {
                return sendable.should_be_sent_after_resource;
            });
        },

        isLoading : (state, getters) => {
            return state.sendables_loading;
        }
    },

    actions: {

        setActiveResourceType ({commit}, resource_type) {
            commit('setActiveResourceType', resource_type);
        },

        deleteSendable ({commit}, sendable) {

            return new Promise((resolve, reject) => {

                http.delete('/app/settings/sendables/' + sendable.id)
                    .then(response => {
                        commit('deleteSendable', sendable.id);
                        resolve(response);
                    }, error => {
                        reject(error);
                    });

            })
        },

        loadSendables ({state, commit}, query_params) {

            if (state.sendables_loading) {
                return;
            }

            commit('setIsLoading', true);

            http.get('/app/settings/sendables', { params: { resource_type : state.active_resource_type } })
                .then(({ data }) => {
                    commit('setSendables', data);
                    commit('setIsLoading', false);
                });
        },

        loadAvailableTags ({state, commit}, query_params) {

            if(!state.is_tags_loaded){
                http.get('/app/settings/sendables/tags', { params: { resource_type : state.active_resource_type } })
                    .then(({ data }) => {
                        commit('setAvailableTags', data);
                        state.is_tags_loaded = true;
                    });
            }

        },

        loadAvailableFilters ({state, commit}, query_params) {

            if(!state.is_filters_loaded){
                http.get('/app/settings/sendables/available-filters', { params: { resource_type : state.active_resource_type } })
                    .then(({ data }) => {
                        commit('setAvailableFilters', data);
                        state.is_filters_loaded = true;
                    });
            }

        },

        loadAvailableTemplates ({state, commit}, query_params) {

            if(!state.is_templates_loaded){
                http.get('/app/settings/sendables/available-templates', { params: { resource_type : state.active_resource_type } })
                    .then(({ data }) => {
                        commit('setAvailableTemplates', data);
                        state.is_templates_loaded = true;
                    });
            }

        }
    }
};
